import {
  Component,
  OnInit,
  AfterViewInit,
   ViewChild,
  ElementRef,
  Renderer2,
} from "@angular/core"; //MOD INE(JJGJ) 20231010 REQ25710 ADD Renderer2
import { SeguridadService } from '../services/seguridad.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpConst } from '../../core/resources/http/http.const';
import { TokenKey } from '../../core/service/tokenKey';
import { empty } from 'rxjs/Observer';
import { RoutesMap } from '../../core/routes.const';
import { HostListener } from '@angular/core';
import { TecladoModel } from '../models/tecladotokenizado/teclado.model';
import { InicioSesionModel } from '../models/main/iniciosesion.model';
import { TokenBanTotal } from '../models/main/tokenBanTotal.model';
import { BodyTeclado } from '../models/generacionclave/paso3/request/BodyTeclado.model'; //INE(JJGJ) 20230727 REQ25238
import { UtilService } from "../../util/util.service";

declare var System: any;
declare var LoginModel: any;
declare var $: any;

//INICIO Dilmer Palomino Pardo (DPP) REQ??? 20190423
export let blnRevisoTerminos: boolean = false;

export function  fRevisoTerminos() {
  blnRevisoTerminos = true;
  return true;
}
//FIN  Dilmer Palomino Pardo (DPP) REQ??? 20190423


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  providers: [SeguridadService, UtilService] // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
})
export class MainComponent implements OnInit {

  public model: any = {};
  public loginMostrado = false;
  public recuperarMostrado = false;
  show: boolean = false; //ADD INE(JJGJ) 20231010 REQ25710
  cantidadValidadiones: number = 0;  //ADD INE(JJGJ) 20231010 REQ25710

  anio:number = new Date().getFullYear(); //INI INE(JJGJ) 20230922 REQ24688
  // INI EXP(CFJC) 20210519 REQ19649
  mostrarTecladoTokenizado: boolean = false;
  teclado: TecladoModel = null;
  digitos: string[] = [];
  count: number = 0;
  _bodyTeclado: BodyTeclado  = null; //INE(JJGJ) 20230727 REQ25238

  @ViewChild('usuario') usuario: ElementRef;
  @ViewChild('contrasenia') contrasenia: ElementRef;

  @ViewChild('judicialAlert') judicialAlert: ElementRef;
  @ViewChild('bloqueadoAlert') bloqueadoAlert: ElementRef;
  @ViewChild('credencialesAlert') credencialesAlert: ElementRef;
  @ViewChild('usernameAlert') usernameAlert: ElementRef;
  @ViewChild('pswdAlert') pswdAlert: ElementRef;   // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
  @ViewChild('noAfiliadoAlert') noAfiliadoAlert: ElementRef;
  @ViewChild('AccesoExpiradoAlert') AccesoExpiradoAlert: ElementRef; // ADD INE(JJGJ) 20230616 REQ25238
  showCaptcha: boolean = false; // ADD INE(JJGJ) 20231010 REQ25710
  // FIN EXP(CFJC) 20210519 REQ19649

  //INI EACN(CSTI) 20231024 REQ25710
  btnIngresar: boolean = false;
  private $api = `${HttpConst.apiUrl}`;
  private $controllerName = "seguridad";
  public captchaUrl: string = `${this.$api}/${this.$controllerName}/Captcha`;
  exp = /^[0-9]+$/; //solo numeros
  private tok = /^[0-9]{4}$/;
  password: string = ""; // Este es tu campo de entrada de pass
  //FIN EACN(CSTI) 20231024 REQ25710
  constructor(
    private seguridadService: SeguridadService,
    private router: Router,
    private render2: Renderer2, //MOD INE(JJGJ) 20231010 REQ25710 ADD Renderer2
    private utilService: UtilService, // ADD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
    ) {}

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    localStorage.clear();
  }
  ngAfterViewInit(){}

  ngOnInit() {
    if(localStorage.getItem("objusuarioGenerarClave")!=null)
    localStorage.removeItem("objusuarioGenerarClave");
    if(localStorage.getItem("objusuarioCambiarClave")!=null)
     localStorage.removeItem("objusuarioCambiarClave");
    if(localStorage.getItem("objSesionCambiarClaveForzada")!=null)
     localStorage.removeItem("objSesionCambiarClaveForzada");

    const me = this;
    me.model.usuario = { } ;
    me.model.usuario.login = null;
    me.model.usuario.password = null;
    this.recuperarMostrado = false;
    this.loginMostrado = true;

    blnRevisoTerminos = false;

    if(localStorage.getItem("objSesionUsuarioLogeado")!=null){
      me.router.navigate(['./'+ RoutesMap.LISTA_CREDITO]);
    }
  }

  mostrarOlvidasteClave() {
    const me = this;

    me.router.navigate(['./cambiarclave']);
  }

  //INI EXP(CFJC) 20210519 REQ19649
  generarTecladoTokenizado() {
    if (this.mostrarTecladoTokenizado === false) {
      let random: number = this.utilService.generateSecureRandom(1, 100); //Math.floor(Math.random() * (1000 - 1 + 1) + 1);  // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
     //INI  INE(JJGJ) 20230727 REQ25238
        this._bodyTeclado = {
          codigo : random.toString()
        }
      //this.seguridadService.generarTecladoTokenizado(random)   //MOD  INE(JJGJ) 20230727 REQ25238 - SE COMENTO
      this.seguridadService.generarTecladoTokenizado(this._bodyTeclado)
      //FIN  INE(JJGJ) 20230727 REQ25238
        .then(
          (result: TecladoModel) => {
            this.teclado = result;
            this.mostrarTecladoTokenizado = true;
          this.show = this.mostrarTecladoTokenizado && this.teclado !== null; // ADD INE(JJGJ) 20231010 REQ25710
        })
        .catch(
          (error) => console.log(error)
        );
    }
  }

  clickBotonTeclado(event: { target: HTMLInputElement }) {
    var target = event.target;
    var id = target.id

    if (this.contrasenia.nativeElement.value.length < 6) {
      this.count++;
      this.contrasenia.nativeElement.value += 'x';
      this.digitos.push(id);
    }
    //INI INE(JJGJ) 20231010 REQ25710
    if (this.contrasenia.nativeElement.value.length == 6) {
      this.showCaptcha = true;
      this.show = false;
      setTimeout(() => {
        this.generarnuevoCaptcha();
      }, 100);
    }
    //fin INE(JJGJ) 20231010 REQ25710
  }

  clickEliminarDigitoTeclado() {
    if (this.contrasenia.nativeElement.value.length > 0) {
      this.contrasenia.nativeElement.value = this.contrasenia.nativeElement.value.slice(0, -1);
      this.digitos.splice(-1, 1);
      this.count--;
    }
  }

  clickBorrarClaveTeclado() {
    this.contrasenia.nativeElement.value = '';
    this.digitos = [];
    this.count = 0;
  }
  //FIN EXP(CFJC) 20210519 REQ19649

  generarClaveWeb() {
    blnRevisoTerminos = false; //Dilmer Palomino Pardo(DPP) REQ??? 20190423
    const me = this;
    me.router.navigate(['./generarclave']);
  }

  cancelar() {
    this.recuperarMostrado = false;
    this.loginMostrado = true;
  }
  onLogin() {
    // MOD EXP(CFJC) 20210519 REQ19649 - Comentado
    // var clave = $("#txtClave").val();
    // $("#username_error").hide();
    // $("#clave_error").hide();
    // $("#incorrectos_error").hide();
    // $("#username_bloqueado").hide();
    // $("#username_bloqueadoJudicial").hide();
    // $("#msgErrorNoAfiliadoWeb").hide();
    // let login = me.model.usuario.login;
    // let password = clave;

    // if(login==="" || login==null){
    //   $('#username_error').show();
    //   return;
    // }

    // if(password==="" || password==null){
    //   $('#clave_error').show();
    //   return;
    // }

    // let _iniciarSesionClienteRequest: {
    //   login: string;
    //   clave: string;
    // };

    // _iniciarSesionClienteRequest = {
    //   login : login,
    //   clave : password
    // }

    // INI EXP(CFJC) 20210519 REQ19649
    // Reiniciar alertas
    (this.usernameAlert.nativeElement as HTMLDivElement).style.display = 'none';
    (this.pswdAlert.nativeElement as HTMLDivElement).style.display = 'none';  // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
    (this.credencialesAlert.nativeElement as HTMLDivElement).style.display =
    'none';
    (this.judicialAlert.nativeElement as HTMLDivElement).style.display = 'none';
    (this.bloqueadoAlert.nativeElement as HTMLDivElement).style.display =
    'none';
    (this.noAfiliadoAlert.nativeElement as HTMLDivElement).style.display =
    'none';

    let inputUsuario: HTMLInputElement = this.usuario.nativeElement;

    if (inputUsuario.value === '') {
      (this.usernameAlert.nativeElement as HTMLDivElement).style.display = 'block';
      return false;
    }

    if (this.digitos.length === 0) {
      (this.pswdAlert.nativeElement as HTMLDivElement).style.display = 'block'; // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
      return false;
    }
    const me = this;

    let _iniciarSesionClienteRequest: InicioSesionModel = {
      login: inputUsuario.value,
      clave: {
        codigo: this.teclado.codigo,
        dispositivo: this.teclado.dispositivo,
        digitos: this.digitos
      }
    }

    me.model.usuario.login = this.usuario.nativeElement.value;
    // FIN EXP(CFJC) 20210519 REQ19649

    this.seguridadService.autenticarUsuario(_iniciarSesionClienteRequest)
    .then(res => {
      if(res!=null){
        // console.log(res)
        let aceptoAccesoWeb:boolean = res.aceptoAccesoWeb;
        let bloqueadoJudicial:boolean = res.bloqueadoJudicial;
        let bloqueado:boolean = res.bloqueado;
        let cambiarClave:boolean = res.cambiarClave;
        let exito:boolean = res.exito;
        let idusuario:string = res.idUsuario;
        let perfil:string = res.perfil;
        let nombreUsuario:string =res.nombreUsuario; //ADD EXP(WTAI) REQ21135 20211221
        let NroDocumento:string = res.nroDocumento; //ADD INE(EGB) 20220623 - REQ22111
        let IdCliente:string = res.idCliente; //ADD INE(EGB) 20220705 - REQ22111
        let accesoExpirado: boolean = res.accesoExpirado; //ADD INE(JJGJ) 20230616 REQ25238
        let claveTemporal: boolean = res.claveTemporal; //ADD REQ CLAVE_TEMPORAL 20240717
        //if(exito) // MOD INE(JJGJ) 20230616 REQ25238 - SE COMENTO
        if(exito && !accesoExpirado) // ADD INE(JJGJ) 20230616 REQ25238
        {
            if(aceptoAccesoWeb){
              if(bloqueado)
              {
                // $("#username_bloqueado").show(); // MOD EXP(CFJC) 20210519 REQ19649 Comentado
                (this.bloqueadoAlert.nativeElement as HTMLDivElement).style.display = 'block'; // ADD EXP(CFJC) 20210519 REQ19649
              }
              else
              {
                if(bloqueadoJudicial)
                {
                  // $("#username_bloqueadoJudicial").show(); // MOD EXP(CFJC) 20210519 REQ19649 Comentado
                  (this.judicialAlert.nativeElement as HTMLDivElement).style.display = 'block'; // ADD EXP(CFJC) 20210519 REQ19649
                }else
                {
                  me.model.usuario = {};
                  me.model.usuario.idusuario = idusuario;
                  me.model.usuario.perfil = perfil;
                  me.model.usuario.login = this.usuario.nativeElement.value; // ADD EXP(CFJC) 20210519 REQ19649
                  me.model.usuario.nombreUsuario= nombreUsuario; //ADD EXP(WTAI) REQ21135 20211221
                  me.model.usuario.NroDocumento = NroDocumento; //ADD INE(EGB) 20220623 - REQ22111
                  me.model.usuario.IdCliente = IdCliente; //ADD INE(EGB) 20220705 - REQ22111
                  me.model.usuario.Expiracion = claveTemporal? false: true; // ADD REQ CLAVE_TEMPORAL 20240722
                  me.model.usuario.ClaveTemporal = claveTemporal? true : false; // ADD REQ CLAVE_TEMPORAL 20240722

                  if(cambiarClave || claveTemporal){
                    me.model.usuario.paso = "1";
                    localStorage.setItem(
                      "objSesionCambiarClaveForzada",
                    JSON.stringify(me.model.usuario)
                    );
                    me.router.navigate(['./cambiarclaveexpirada']);
                  }else{
                    let tokenlocal = new TokenKey();
                    tokenlocal.accessToken = res.accessToken;
                    tokenlocal.refreshToken = res.refreshToken;
                    tokenlocal.expiresOn = res.expiresOn;
                    localStorage.setItem
                    (HttpConst.LOCAL_STORAGE_KEY_TOKEN,
                    JSON.stringify(tokenlocal)
                    );
                    localStorage.setItem(
                      "objSesionUsuarioLogeado",
                       JSON.stringify(me.model.usuario)
                  );

                    // INICIO EXP(SMM) 20220111 - REQ21426 Se obtiene el token otorgado por Ban Total para el uso de sus servicios
                    let _tokenBanTotalRequest: TokenBanTotal = {
                      idUsuario: parseInt(me.model.usuario.idusuario),
                    };

                   this.seguridadService
                    .generarTokenBanTotal(_tokenBanTotalRequest)
                     .subscribe((result) => {
                      localStorage.setItem(
                       "objBanTotalCredentials",
                       JSON.stringify(result.data)
                       );

                        if (perfil == "Cliente") {
                         me.router.navigate(["./" + RoutesMap.LISTA_CREDITO]);
                     }
                  if(perfil=='Administrador' || perfil=='ROL OPERATIVO'){ //MOD INE(JJGJ) 20221018 - REQ22978 - ADD ROL OPERATIVO
                      me.router.navigate(['./'+ RoutesMap.ADMINISTRACION]);
                       }
                      });


                    // FIN EXP(SMM) 20220111 - REQ21426

                  //  if(perfil=='Cliente'){
                 //     me.router.navigate(['./'+ RoutesMap.LISTA_CREDITO]);
                 //   }
                 //   if(perfil=='Administrador' || perfil=='ROL OPERATIVO'){ //MOD INE(JJGJ) 20221018 - REQ22978 - ADD ROL OPERATIVO
                 //     me.router.navigate(['./'+ RoutesMap.ADMINISTRACION]);
                 //   }
                    this.OnPrestamoPersonal(); //ADD INE(EGB) 20220705 - REQ22111
                  }
                }
              }
            }else{
              // $("#msgErrorNoAfiliadoWeb").show(); // MOD EXP(CFJC) 20210519 REQ19649 Comentado
              (this.noAfiliadoAlert.nativeElement as HTMLDivElement).style.display = 'block'; // ADD EXP(CFJC) 20210519 REQ19649
            }
        }
        else
        {
	// INI INE(JJGJ) 20230616 REQ25238
          if(accesoExpirado){
            (this.AccesoExpiradoAlert.nativeElement as HTMLDivElement).style.display = 'block';
                    setTimeout(() => {
                      (this.AccesoExpiradoAlert.nativeElement as HTMLDivElement).style.display = 'none';
                    }, 4000);
          }else{
	  // FIN INE(JJGJ) 20230616 REQ25238
          // $('#incorrectos_error').show(); // MOD EXP(CFJC) 20210519 REQ19649 Comentado
          (this.credencialesAlert.nativeElement as HTMLDivElement).style.display = 'block'; // ADD EXP(CFJC) 20210519 REQ19649
          } // ADD INE(JJGJ) 20230616 REQ25238
        }
      }

    }).catch(err => {
      if (err.status === 401) {
        // $('#incorrectos_error').show(); // MOD EXP(CFJC) 20210519 REQ19649 Comentado
        (this.credencialesAlert.nativeElement as HTMLDivElement).style.display = 'block'; // ADD EXP(CFJC) 20210519 REQ19649
      }
      console.log(err);
    });
  }

  //INICIO: INE(EGB) 20220607 - REQ22111
  OnPrestamoPersonal(){
    const me = this;
    let _ObtenerDatosCreditoRequest: {
      idcliente: string,
      idUsuario:string
    };

    _ObtenerDatosCreditoRequest = {
      idcliente: me.model.usuario.IdCliente,
      idUsuario:me.model.usuario.idusuario
    };


    this.seguridadService
      .obtenerPrestamoPersonal(_ObtenerDatosCreditoRequest)
      .then(res => {
        if (res.data != null) {
          if (res.data.length > 0) {
            $('#AlertaPersonal').show();
          }
        }
      })
      .catch(err => {
        console.log(err);
      });


  }
  //FIN: INE(EGB) 20220607 - REQ22111
  //INI EACN(CSTI) 20231024 REQ25710
  validarLongitudPass() {
    if (this.model.usuario.code && this.model.usuario.code.length == 4) { //INE(PVR) REQ25710 20231031
    this.cantidadValidadiones ++;
    // console.log(this.cantidadValidadiones)

    const me = this;
    let usuarioValido = this.esCampoValido(
      me.model.usuario.login,
      this.exp,
      "#usuario"
    );
    const countCaracteresClave = this.digitos.length;
    let capchaVerificado: boolean = false;
    var codigoValido = false;
    let _verificarCaptchaRequest: {
      code: string;
    };
    _verificarCaptchaRequest = {
      code: me.model.usuario.code,
    };

    if (countCaracteresClave === 6 && usuarioValido) {
      if (me.model.usuario.code != null) {
        if (me.model.usuario.code.length === 4) {
          if (!this.btnIngresar) {
            this.seguridadService
              .verificarCaptcha(_verificarCaptchaRequest)
              .then((res) => {

                codigoValido = res.data.esValido;
                if (!codigoValido) {
                  $("#cap1").show();
                  capchaVerificado = false;
                } else {
                  $("#cap1").hide();
                  capchaVerificado = true;
                  this.btnIngresar = true;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      }
    // return this.btnIngresar; //INE(PVR) REQ25710 20231031
    }
  }
  }
  generarnuevoCaptcha() {
    let randomNumber = this.utilService.generateSecureRandom(1, 100); //Math.floor(Math.random() * 100);  // MOD EXP(CMOGOLLON) 20241212 MEJORA_SEGURIDAD
    // console.log(randomNumber);
    $("#code").css(
      "background-image",
      'url("' + this.captchaUrl + "/" + randomNumber + '")'
    );
    this.btnIngresar=false; //INE(PVR) REQ25710 20231031
  }
  esCampoValido(valor, expresion, labelError) {
    let esValido: boolean = false;

    if (valor == null || valor === "" || !expresion.test(valor)) {
      $(labelError).show();
      esValido = false;
    } else {
      $(labelError).hide();
      esValido = true;
    }
    return esValido;
  }
  //FIN EACN(CSTI) 20231024 REQ25710
}
